import { render } from "./WCCouponNotAvailableRibbon.vue?vue&type=template&id=7884365c&scoped=true&ts=true"
import script from "./WCCouponNotAvailableRibbon.vue?vue&type=script&lang=ts"
export * from "./WCCouponNotAvailableRibbon.vue?vue&type=script&lang=ts"

import "./WCCouponNotAvailableRibbon.vue?vue&type=style&index=0&id=7884365c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7884365c"]])

export default __exports__